import React from 'react';
import { View, ScrollView, StyleSheet, Linking, TouchableOpacity, Text, Platform } from 'react-native';
import { Title, Paragraph, IconButton } from 'react-native-paper';
import { MaterialCommunityIcons } from '@expo/vector-icons';

export default function ContactPage({ onClose }) {
  const isWeb = Platform.OS === 'web';

  const handleEmailPress = () => {
    const email = 'info@samataplay.com';
    const subject = 'Şamata Play İletişim';
    const body = 'Merhaba,\n\n';
    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    Linking.openURL(mailtoLink).catch(err => {
      console.error('Email açılamadı:', err);
      if (isWeb) {
        // Web'de clipboard'a kopyala
        if (navigator.clipboard) {
          navigator.clipboard.writeText(email);
          alert('E-posta adresi kopyalandı: ' + email);
        }
      }
    });
  };

  const handleTwitterPress = () => {
    const twitterUrl = 'https://twitter.com/samataplay';
    Linking.openURL(twitterUrl).catch(err => {
      console.error('Twitter açılamadı:', err);
    });
  };

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Title style={styles.title}>İletişim</Title>
        <IconButton
          icon={() => <MaterialCommunityIcons name="close" size={24} color="#FFFFFF" />}
          onPress={onClose}
          style={styles.closeButton}
        />
      </View>
      <ScrollView style={styles.content} contentContainerStyle={styles.contentContainer}>
        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>Bizimle İletişime Geçin</Title>
        </Paragraph>
        
        <Paragraph style={styles.paragraph}>
          Şamata Play hakkında sorularınız, önerileriniz, destek talepleriniz veya iş birliği 
          teklifleriniz için aşağıdaki iletişim kanallarını kullanabilirsiniz.
        </Paragraph>

        <View style={styles.contactCard}>
          <MaterialCommunityIcons name="email" size={32} color="#E94560" />
          <Title style={styles.contactTitle}>E-posta</Title>
          <TouchableOpacity onPress={handleEmailPress}>
            <Paragraph style={styles.contactLink}>info@samataplay.com</Paragraph>
          </TouchableOpacity>
          <Paragraph style={styles.contactDescription}>
            E-posta göndermek için yukarıdaki adrese tıklayın
          </Paragraph>
        </View>

        <View style={styles.contactCard}>
          <MaterialCommunityIcons name="twitter" size={32} color="#E94560" />
          <Title style={styles.contactTitle}>Twitter</Title>
          <TouchableOpacity onPress={handleTwitterPress}>
            <Paragraph style={styles.contactLink}>@samataplay</Paragraph>
          </TouchableOpacity>
          <Paragraph style={styles.contactDescription}>
            Twitter'da bizi takip edin ve mesaj gönderin
          </Paragraph>
        </View>

        <View style={styles.contactCard}>
          <MaterialCommunityIcons name="web" size={32} color="#E94560" />
          <Title style={styles.contactTitle}>Web Sitesi</Title>
          <Paragraph style={styles.contactText}>www.samataplay.com</Paragraph>
          <Paragraph style={styles.contactDescription}>
            Resmi web sitemizi ziyaret edin
          </Paragraph>
        </View>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>Destek Saatleri</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          E-posta desteği: 7/24{'\n'}
          Yanıt süresi: 24-48 saat içinde
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Title style={styles.sectionTitle}>Sık Sorulan Sorular</Title>
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Text style={styles.bold}>S: Şamata Play ücretsiz mi?</Text>
          {'\n'}C: Evet, Şamata Play tamamen ücretsizdir. Radyo dinleme, oyun oynama ve 
          sohbet özelliklerinin tümü ücretsizdir.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Text style={styles.bold}>S: Nasıl hesap oluşturabilirim?</Text>
          {'\n'}C: Şamata Play'de hesap oluşturmanıza gerek yok. Uygulamayı açtığınızda 
          otomatik olarak bir kullanıcı adı atanır ve hemen kullanmaya başlayabilirsiniz.
        </Paragraph>

        <Paragraph style={styles.paragraph}>
          <Text style={styles.bold}>S: Radyo çalmıyor, ne yapmalıyım?</Text>
          {'\n'}C: Lütfen internet bağlantınızı kontrol edin. Sorun devam ederse, 
          farklı bir radyo deneyin veya bize ulaşın.
        </Paragraph>

        <View style={styles.footer}>
          <Paragraph style={styles.footerText}>
            © 2024 Şamata Play. Tüm hakları saklıdır.
          </Paragraph>
        </View>
      </ScrollView>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000000',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingTop: Platform.OS === 'web' ? 20 : 40,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#333333',
  },
  title: {
    color: '#FFFFFF',
    fontSize: 24,
    fontWeight: 'bold',
  },
  closeButton: {
    margin: 0,
  },
  content: {
    flex: 1,
  },
  contentContainer: {
    padding: 20,
    paddingBottom: 40,
  },
  paragraph: {
    color: '#CCCCCC',
    fontSize: 16,
    lineHeight: 24,
    marginBottom: 20,
  },
  sectionTitle: {
    color: '#FFFFFF',
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 10,
    marginTop: 10,
  },
  bold: {
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  contactCard: {
    backgroundColor: '#111111',
    borderRadius: 12,
    padding: 20,
    marginBottom: 20,
    alignItems: 'center',
    borderWidth: 1,
    borderColor: '#333333',
  },
  contactTitle: {
    color: '#FFFFFF',
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 12,
    marginBottom: 8,
  },
  contactLink: {
    color: '#E94560',
    fontSize: 16,
    textDecorationLine: 'underline',
    marginBottom: 8,
  },
  contactText: {
    color: '#CCCCCC',
    fontSize: 16,
    marginBottom: 8,
  },
  contactDescription: {
    color: '#888888',
    fontSize: 14,
    textAlign: 'center',
  },
  footer: {
    marginTop: 40,
    paddingTop: 20,
    borderTopWidth: 1,
    borderTopColor: '#333333',
  },
  footerText: {
    color: '#888888',
    fontSize: 14,
    textAlign: 'center',
  },
});

